import { createFileRoute } from "@tanstack/react-router";
import InstallationsPage from "@/pages/Installations";

export const Route = createFileRoute("/installations")({
  head: () => ({
    meta: [
      { title: "Done[x] — Installations" },
      {
        name: "description",
        content: "Connect Done[x] to your Slack workspaces and manage active integrations.",
      },
    ],
  }),
  component: InstallationsPage,
});
